import networkAdapter from '../adapters/network';

export const submitPrescription = ({ 
  productId,
  fieldId,
  selectedTrialPlacementId,
  year,
  cropName,
  seasonName,
  applicationRate
}) => {
  const graphRequest = {
    query: `
      mutation CreatePfPRecommendation(
        $productId: ID!
        $fieldId: ID!
        $selectedTrialPlacementId: ID!
        $year: Int!
        $cropName: String!
        $seasonName: AgronomicSeasonName!
        $applicationRate: ApplicationRate!
      ) {
        createPfPRecommendation(input: {
          productId: $productId
          fieldId: $fieldId
          selectedTrialPlacementId: $selectedTrialPlacementId
          year: $year
          cropName: $cropName
          seasonName: $seasonName
          applicationRate: $applicationRate
        }) {
          jobId
        }
      }
    `,
    variables: {
      productId, fieldId, selectedTrialPlacementId, year, cropName, seasonName, applicationRate
    },
    olVersion: '2'
  };

  return networkAdapter({
    options: graphRequest,
    useOL: true
  });
};
